import { getData, postData } from '../../../utils/fetch-api-util';
import { TourTrashType, TourTrashUserType } from '../../../types/tourtrash';
import { API_URLS } from '../../../constants/urls/api-urls';

export interface TourTrashRequestParams {
  take?: number;
  page?: number;
  status?: string;
  startDate?: string;
  endDate?: string;
  country?: string;
}

export interface TourtrashEnteredUsersRequestParams {
  take: number;
  page: number;
  tourTrashId: string;
  emailOrName?: string;
}

export interface UpdateTourTrashPayload {
  id: string;
}

export interface PickTourtrashWinnerPayload {
  userId: string;
  tourTrashId: string;
}

export interface PickTourtrashPickRandomWinnerPayload {
  perPage: number;
  tourTrashId: string;
}

export interface CreateOrUpdateTourTrashPayload {
  id?: string;
  title?: string;
  description?: string;
  startDate?: string;
  endDate?: string;
  remindPushNotificationFrequency?: number;
  sendEmailTo?: number;
  pushNotificationTo?: number;
  participationLevel?: string;
  product?: {
    id?: string;
    name: string;
    detail: string;
    legal: string;
    images?: {
      id?: string;
      imageUrl?: string;
    }[];
    videoType?: string;
    videoId?: string;
  };
  sendEmailAtLaunch?: boolean;
  pushNotificationAtLaunch?: boolean;
  timeToSendEmailBeforeEndDate?: number; // second
  timeToPushNotificationBeforeEndDate?: number; // second
  timeToAutoCloseAfterEndDate?: number; // second
  countries?: string;
  options?: string;
}
export interface GetTourtrashEnteredUsersResponse {
  total: number;
  take: number;
  page: number;
  data: TourTrashUserType[];
}
export interface TourtrashResponse {
  total: number;
  take: number;
  page: number;
  data: TourTrashType[];
}
export const getTourTrashListRepository = async (
  url: string,
  data?: TourTrashRequestParams,
): Promise<TourtrashResponse> => {
  const response = await getData<TourTrashRequestParams, TourtrashResponse>(url, data);
  return response.data as TourtrashResponse;
};
export const getTourTrashEnteredUsersRepository = async (
  url: string,
  data?: TourtrashEnteredUsersRequestParams,
): Promise<GetTourtrashEnteredUsersResponse> => {
  const response = await getData<TourtrashEnteredUsersRequestParams, GetTourtrashEnteredUsersResponse>(url, data);
  return response.data as GetTourtrashEnteredUsersResponse;
};

export const postCreateOrUpdateTourTrash = async (payload: CreateOrUpdateTourTrashPayload): Promise<any> => {
  await postData(API_URLS.SAVE_TOUR_TRASH, payload);
  return true;
};

export const postDeleteTourTrash = async (payload: UpdateTourTrashPayload): Promise<boolean> => {
  await postData(API_URLS.DELETE_TOURTRASH, payload);
  return true;
};

export const postArchiveTourTrash = async (payload: UpdateTourTrashPayload): Promise<boolean> => {
  await postData(API_URLS.ARCHIVE_TOURTRASH, payload);
  return true;
};

export const postActivateTourTrash = async (payload: UpdateTourTrashPayload): Promise<boolean> => {
  await postData(API_URLS.ACTIVATE_TOURTRASH, payload);
  return true;
};

export const postCancelTourTrash = async (payload: UpdateTourTrashPayload): Promise<boolean> => {
  await postData(API_URLS.CANCEL_TOURTRASH, payload);
  return true;
};

export const postCloseTourTrash = async (payload: UpdateTourTrashPayload): Promise<boolean> => {
  await postData(API_URLS.CLOSE_TOURTRASH, payload);
  return true;
};

export const postTourTrashPickWinner = async (payload: PickTourtrashWinnerPayload): Promise<any> => {
  return postData(API_URLS.TOURTRASH_PICK_WINNER, payload);
};

export const postTourTrashPickRandomWinner = async (payload: PickTourtrashPickRandomWinnerPayload): Promise<any> => {
  return postData(API_URLS.TOURTRASH_SELECT_RANDOM_WINNER, payload);
};
